module.exports = __webpack_public_path__ + "static/media/002-teeth.b6db6fb0.svg";